import { render } from "./QuyetDinh.vue?vue&type=template&id=87466582"
import script from "./QuyetDinh.vue?vue&type=script&lang=js"
export * from "./QuyetDinh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__